export default __webpack_public_path__ + "static/media/Master_Mix.782e993d.svg";